import { FC } from 'react';
import l from '../../../../lang';
import Dialog from '../../../common/dialog';
import CardConfirm from '../../../common/confirm/card-confirm';
import DialogConfirm from '../../../common/confirm/dialog-confirm';

interface DialogDeleteUserProps {
  userEmail: string;
  onClose: (confirm: boolean) => void;
}

const DialogDeleteUser: FC<DialogDeleteUserProps> = ({ userEmail, onClose }) => {
  return (
    <DialogConfirm onClose={() => onClose(false)}>
      <CardConfirm
        onClose={onClose}
        headline={l('userManagement.delete.title')}
        description={l('userManagement.delete.body', `${userEmail}`)}
        confirmChildren={l('userManagement.delete.confirm')}
        cancelChildren={l('userManagement.delete.no')}
        level={'delete'}
      />
    </DialogConfirm>
  );
};

export default DialogDeleteUser;
